// components/CreateTagModal.jsx
import React from "react";

const CreateTagModal = ({
  isOpen,
  onClose,
  fieldName,
  setFieldName,
  selectedColor,
  setSelectedColor,
  fieldPrompt,
  setFieldPrompt,
  colorOptions,
  handleAddField
}) => {
  if (!isOpen) return null;

  return (
    <div className="custom-modal-overlay-inline show">
      <div className="custom-modal-content-custom active relative w-[420px]">
        <button
          className="close-modal-custom"
          onClick={onClose}
        >
          ×
        </button>

        <h2 className="text-lg font-semibold mb-1">Create tag</h2>
        <p className="text-[13px] font-[400] font-[Outfit] leading-normal text-[#73607B] mb-4">
          Create & Add tags to your documents to make them easier to find
        </p>

        {/* Name Input */}
        <label className="text-[#18101C] font-[500] text-[15px] leading-normal font-[Outfit] self-stretch mb-1">
          Name
        </label>
        <input
          type="text"
          className="w-full border border-[rgba(0,0,0,0.10)] rounded-[6px] px-4 py-4 mb-4 text-[13px] font-[Outfit] focus:outline-none focus:border-[#6F52ED] hover:border-[#6F52ED]"
          placeholder="Eg: Contracts"
          value={fieldName}
          onChange={(e) => setFieldName(e.target.value)}
        />

        {/* Color Picker */}
        <label className="text-[#18101C] font-[500] text-[15px] leading-normal font-[Outfit] self-stretch mb-2">
          Color
        </label>
        <div className="flex flex-wrap gap-2 mb-4">
          {colorOptions.map((color, index) => (
            <div
              key={index}
              className="w-6 h-6 rounded-md border border-[rgba(0,0,0,0.10)] cursor-pointer"
              style={{
                backgroundColor: color,
                outline: selectedColor === color ? '2px solid black' : 'none',
              }}
              onClick={() => setSelectedColor(color)}
            />
          ))}
        </div>

        {/* Description */}
        <label className="text-[#18101C] font-[500] text-[15px] leading-normal font-[Outfit] self-stretch mb-2">
          Description{" "}
          <span className="text-[13px] font-[400] font-[Outfit] leading-normal text-[#73607B]">
            (Optional)
          </span>
        </label>
        <textarea
          rows={3}
          className="w-full h-[94px] self-stretch rounded-[6px] border border-[rgba(0,0,0,0.10)] px-4 pt-[13px] text-[13px] font-[400] font-[Outfit] leading-normal text-[#52525B] placeholder:text-[#52525B] placeholder:opacity-64 placeholder:font-[Outfit] placeholder:text-[13px] placeholder:font-[400] placeholder:leading-normal resize-none relative focus:outline-none focus:border-[#6F52ED] hover:border-[#6F52ED]"
          placeholder="Eg: All the Contracts Signed by the company"
          value={fieldPrompt}
          onChange={(e) => setFieldPrompt(e.target.value)}
        />

        {/* Create Button */}
        <button
  className={`absolute bottom-4 right-5 flex justify-center items-center gap-2 px-9 py-[10px] rounded-[6px] text-white text-sm font-semibold
    ${!fieldName || !selectedColor
      ? 'bg-[#E1CFE9] cursor-not-allowed'
      : 'bg-[#C95EBE] hover:bg-[#b04aad]'}`}
  onClick={handleAddField}
  disabled={!fieldName || !selectedColor}
>
  <span className="text-[#EAF7FF] font-[Outfit] text-[16px] font-semibold leading-[24px] tracking-[0.16px]">
    Create Tag
  </span>
</button>

      </div>
    </div>
  );
};

export default CreateTagModal;
